import OptionConst from "@/const/Option"
import { BaseOption } from "@/types/Option"

export function useForm() {
  const isEtc = (options: BaseOption[], val: number) => {
    const opt = options.find((v: BaseOption) => v.val === val)
    // 非活性にするかの判断なので、その他の場合にfalseを返す
    if (opt && opt.code === OptionConst.ETC) {
      return false
    } else {
      return true
    }
  }

  const getError = (form: any, key: string) => {
    if (form.errors) {
      if (form.errors[key]) {
        if (Array.isArray(form.errors[key])) {
          // 複数表示せずに1件だけ表示
          return form.errors[key][0]
        } else {
          return form.errors[key]
        }
      }
    }
    return ''
  }

  const setError = (form: any, key: string, message: string) => {
    if (!form.errors) {
      form.errors = {}
    }
    form.errors[key] = message
  }

  const removeError = (form: any, key: string) => {
    if (form.errors) {
      if (form.errors[key]) {
        delete form.errors[key]
      }
    }
  }

  const removeAllError = (form: any) => {
    if (typeof form !== 'object') {
      // オブジェクトじゃないなら処理しない
      return
    }
    for (let key in form) {
      if (key === 'errors') {
        delete form.errors
      } else {
        if (Array.isArray(form[key])) {
          for (let idx = 0; idx < form[key].length; idx++) {
            // 再帰処理
            removeAllError(form[key][idx])
          }
        }
      }
    }
  }

  return {
    isEtc,
    getError,
    setError,
    removeError,
    removeAllError
  }
}